var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.39 15.67L13.35 12H10.64L6.6 15.67C5.47 16.69 5.1 18.26 5.65 19.68C6.2 21.09 7.54 22 9.05 22H14.94C16.46 22 17.79 21.09 18.34 19.68C18.89 18.26 18.52 16.69 17.39 15.67ZM13.82 18.14H10.18C9.8 18.14 9.5 17.83 9.5 17.46C9.5 17.09 9.81 16.78 10.18 16.78H13.82C14.2 16.78 14.5 17.09 14.5 17.46C14.5 17.83 14.19 18.14 13.82 18.14Z",
    fill: "#F29339"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.35 4.32C17.8 2.91 16.46 2 14.95 2L9.05 2C7.54 2 6.2 2.91 5.65 4.32C5.11 5.74 5.48 7.31 6.61 8.33L10.65 12H13.36L17.4 8.33C18.52 7.31 18.89 5.74 18.35 4.32ZM13.82 7.23L10.18 7.23C9.8 7.23 9.5 6.92 9.5 6.55C9.5 6.18 9.81 5.87 10.18 5.87H13.82C14.2 5.87 14.5 6.18 14.5 6.55C14.5 6.92 14.19 7.23 13.82 7.23Z",
    fill: "#F29339"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.93e1f3c8e7c50ee8ad071fb583419b79.svg";
export { ForwardRef as ReactComponent };